import React from "react";
import { Alert } from "reactstrap";

export const NotFoundPage = () => (
	<div>
		<Alert color="danger">The page you are attempting to visit has not been found.</Alert>
	</div>
);

export default NotFoundPage;
